// Copyright (c) 2025 Deere & Company

import actions from '../../actions-list';

export const toggleSelectAllRecords = (laborRates, currentAllSelectedState) =>
    dispatch => {

        // Select or deselect all dealers based on the current state

        if (currentAllSelectedState) {

            // Deselect all dealers

            dispatch({
                type: actions.RESET_TCSM_SELECTED_DEALERS
            });

        } else {

            // Select all dealers

            laborRates.forEach(laborRate => {

                dispatch({
                    dealer: laborRate,
                    isSelected: true,
                    type: actions.UPDATE_TCSM_SELECTED_DEALER_ACCOUNTS
                });

            });

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/action-creators/toggle-select-all.js